import { RepositoryFactory } from "@/Apicall/masters/RepositoryFactory";
const getN = RepositoryFactory.get("getNotify")
export default {
    getAllNotification({ commit }, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await getN.getAllNotification(payload)
               
                resolve(data);
            } catch (error) {
                console.log(error);
                reject(error);
            }
        });
    },
    editNotification({ commit }, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await getN.editNotification(payload)
               
                resolve(data);
            } catch (error) {
                console.log(error);
                reject(error);
            }
        });
    },
}